import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },

  // 生徒権限画面
  {
    path: '/student/login',
    name: 'StudentLogin',
    meta: { layout: 'none' },
    component: () => import('../views/student/Login.vue'),
  },
  {
    // 練習問題画面
    path: '/student/practice',
    name: 'StudentPractice',
    meta: { layout: 'study' },
    component: () => import('../views/student/Practice.vue'),
  },
  {
    // テスト開始画面
    path: '/student/study-start',
    name: 'StudentStudyStart',
    meta: { layout: 'student-authed' },
    component: () => import('../views/student/StudyStart.vue'),
  },
  {
    // テスト開始画面
    path: '/student/study-result',
    name: 'StudentStudyResult',
    meta: { layout: 'student-authed' },
    component: () => import('../views/student/StudyResult.vue'),
  },
  {
    // テスト画面
    path: '/student/study',
    name: 'StudentStudy',
    meta: { layout: 'study' },
    component: () => import('../views/student/Study.vue'),
  },

  // 管理者権限画面
  {
    // ログイン画面
    path: '/admin/login',
    name: 'AdminLogin',
    meta: { layout: 'none' },
    component: () => import('../views/admin/Login.vue'),
  },
  {
    // 教室一覧画面
    path: '/admin/branch-list',
    name: 'AdminBranchList',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/BranchList.vue'),
  },
  {
    // 教室個別登録画面
    path: '/admin/branch-create',
    name: 'AdminBranchCreate',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/BranchCreate.vue'),
  },
  {
    // 教室編集画面
    path: '/admin/branch-edit/:branchId',
    name: 'AdminBranchEdit',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/BranchEdit.vue'),
  },
  {
    // 講師一覧画面
    path: '/admin/branch/:branchId/teacher-list',
    name: 'AdminTeacherList',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/TeacherList.vue'),
  },
  {
    // 講師個別登録画面
    path: '/admin/branch/:branchId/teacher-create',
    name: 'AdminTeacherCreate',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/TeacherCreate.vue'),
  },
  {
    // 講師編集画面
    path: '/admin/teacher-edit/:teacherId',
    name: 'AdminTeacherEdit',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/TeacherEdit.vue'),
  },
  {
    // 生徒一覧画面
    path: '/admin/branch/student-list/:branchId',
    name: 'AdminStudentList',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/StudentList.vue'),
  },
  {
    // 生徒個別登録画面
    path: '/admin/branch/:branchId/student-create/',
    name: 'AdminStudentCreate',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/StudentCreate.vue'),
  },
  {
    // 生徒編集画面
    path: '/admin/student-edit/:studentId',
    name: 'AdminStudentEdit',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/StudentEdit.vue'),
  },
  {
    // 帳票出力画面
    path: '/admin/output-report',
    name: 'AdminOutputReport',
    meta: { layout: 'admin-authed' },
    component: () => import('../views/admin/OutputReport.vue'),
  },

  // 教室権限画面
  {
    path: '/branch/login',
    name: 'BranchLogin',
    meta: { layout: 'none' },
    component: () => import('../views/branch/Login.vue'),
  },
  {
    // 生徒一覧画面
    path: '/branch/student-list',
    name: 'BranchStudentList',
    meta: { layout: 'branch-authed' },
    component: () => import('../views/branch/StudentList.vue'),
  },
  {
    // 正誤結果画面
    path: '/branch/study-result/:acbtCode',
    name: 'BranchStudyResult',
    meta: { layout: 'branch-authed' },
    component: () => import('../views/branch/StudyResult.vue'),
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
